import { GOOGLE_FONTS_RANGES } from "@excalidraw/common";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import LatinExt from "./Poppins-Regular-pxiEyp8kv8JHgFVrJJbecnFHGPezSQ.woff2";
import Latin from "./Poppins-Regular-pxiEyp8kv8JHgFVrJJnecnFHGPezSQ.woff2";

export const PoppinsFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: LatinExt,
    descriptors: {
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN_EXT,
      weight: "400",
    },
  },
  {
    uri: Latin,
    descriptors: {
      unicodeRange: GOOGLE_FONTS_RANGES.LATIN,
      weight: "400",
    },
  },
];
